// Le vocabulaire des lieux, fermé et unique. Il sert à trois choses : les zones où un
// profil intervient, les zones d'une mission, et la région par laquelle une annonce
// publiée décrit son client.
//
// Fermé, parce qu'un champ libre rend le rapprochement idiot — « IDF », « Ile de France »
// et « Île-de-France » ne se croisent pas — et parce que la règle d'anonymisation des
// annonces ne tient que si personne ne peut y écrire « Lille ».

export const GROUPES_ZONES = {
  'Régions': [
    'Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Bretagne', 'Centre-Val de Loire',
    'Corse', 'Grand Est', 'Hauts-de-France', 'Île-de-France', 'Normandie', 'Nouvelle-Aquitaine',
    'Occitanie', 'Pays de la Loire', "Provence-Alpes-Côte d'Azur", 'Outre-mer',
  ],
  'Hors de France': [
    'Belgique', 'Luxembourg', 'Suisse', 'Allemagne', 'Royaume-Uni', 'Espagne', 'Italie',
    'Pays-Bas', 'Europe (autre)', 'Amérique du Nord', 'Afrique', 'Moyen-Orient',
    'Asie-Pacifique', 'International',
  ],
  'Sans lieu fixe': ['France entière', 'À distance'],
} as const;

export const ZONES = [
  ...GROUPES_ZONES['Régions'],
  ...GROUPES_ZONES['Hors de France'],
  ...GROUPES_ZONES['Sans lieu fixe'],
] as const;

export type Zone = (typeof ZONES)[number];
